export class EdelError extends Error {
    constructor(code, error) {
        super();
        this.getHttpCode = () => {
            if (!this.httpCode)
                return 0;
            return this.httpCode;
        };
        this.getErrorCode = () => {
            if (this.errorParams == null || this.errorParams.error.errorCode == null)
                return "0";
            return this.errorParams.error.errorCode;
        };
        this.getErrorMessege = () => {
            if (this.errorParams == null || this.errorParams.error.errorMessage == null)
                return '"Something went wrong"';
            return this.errorParams.error.errorMessage;
        };
        this.getErrCd = () => {
            if (this.errorParams == null || this.errorParams.error.errCd == null)
                return "0";
            return this.errorParams.error.errCd;
        };
        this.getErrMsg = () => {
            if (this.errorParams == null || this.errorParams.error.errMsg == null)
                return "Something went wrong! Please try after sometime.";
            return this.errorParams.error.errMsg;
        };
        this.getActionCode = () => {
            if (this.errorParams == null || this.errorParams.error.actionCode == null)
                return "Something went wrong! Please try after sometime.";
            return this.errorParams.error.actionCode;
        };
        this.getStatus = () => {
            if (this.errorParams == null)
                return false;
            return this.errorParams.status;
        };
        this.getErrorMessageOrErrMsg = () => {
            if (this.errorParams == null &&
                this.errorParams.error.errMsg == null &&
                this.errorParams.error.errorMessage == null)
                return "Something went wrong! Please try after sometime.";
            return this.errorParams.error.errMsg || this.errorParams.error.errorMessage;
        };
        Object.setPrototypeOf(this, EdelError.prototype);
        this.httpCode = code;
        this.errorParams = error;
    }
}
